import { useState } from "react";
import { Archive } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { niceName } from "@/lib/format";

const ACTION = { export: "Exportou", export_all: "Exportou todas", pdf: "Abriu o PDF" };
const when = (iso) => new Date(iso).toLocaleString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export function ExportAllButton({ total, disabled, onConfirm }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} disabled={disabled} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-ec-green border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-50 transition-colors" data-testid="kyc-archive-export-all">
        <Archive size={15} /> Exportar todas
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="kyc-archive-export-all-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Exportar todas as fichas</AlertDialogTitle>
            <AlertDialogDescription data-testid="kyc-archive-export-all-text">Vai exportar {total} fichas com dados pessoais. Continuar?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="kyc-archive-export-all-cancel">Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={onConfirm} className="bg-ec-green hover:bg-ec-green/90" data-testid="kyc-archive-export-all-confirm">Exportar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}

export function KycArchiveLog({ log }) {
  return (
    <div className="bg-white rounded-[16px] border border-slate-100 p-4 md:p-5" data-testid="kyc-archive-log">
      <h2 className="font-heading text-lg text-ec-green">Registo de exportações e PDFs</h2>
      {!log.length ? <p className="text-sm text-slate-400 mt-2">Ainda ninguém exportou nem abriu fichas.</p> : (
        <ul className="mt-3 divide-y divide-slate-100 text-sm">
          {log.map((l) => (
            <li key={l.id} className="py-2.5 flex flex-wrap gap-x-3 gap-y-0.5" data-testid={`kyc-archive-log-${l.id}`}>
              <span className="tabular-nums text-slate-500 w-36 shrink-0">{when(l.at)}</span>
              <span className="font-medium text-ec-green">{niceName(l.by)}</span>
              <span>{ACTION[l.action]}{l.action === "pdf" ? `: ${l.name}` : ` · ${l.count} ficha${l.count === 1 ? "" : "s"}`}</span>
              {l.filter && <span className="text-slate-500">pesquisa {l.filter}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
